import { css } from '@emotion/core'
import React from 'react'

import { Link } from '../components/Link'
import FacebookIcon from '../icons/social/logo-facebook.svg'
import LinkedinIcon from '../icons/social/logo-linkedin.svg'
import XIcon from '../icons/social/logo-x.svg'

const SocialSharing: React.FC<{ blackBG?: boolean; title: string }> = ({ blackBG = false, title }) => {
  if (typeof window === `undefined`) {
    return null
  }

  const twitterHref = `https://twitter.com/intent/tweet?text=${title} ${window.location.href} via @airfocusApp`
  const Facebook = `https://www.facebook.com/sharer.php?u=${window.location.href}`
  const linkedinHref = `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}%2F&title=${title}&summary=${title}`
  return (
    <div css={containerStyle}>
      <span className="heading4">Share</span>
      <Link href={Facebook}>
        <FacebookIcon className={`opacity-on-hover ${blackBG ? 'white-icon' : undefined}`} css={socialIconStyle} />
      </Link>
      <Link href={linkedinHref}>
        <LinkedinIcon className={`opacity-on-hover ${blackBG ? 'white-icon' : undefined}`} css={socialIconStyle} />
      </Link>
      <Link href={twitterHref}>
        <XIcon className={`opacity-on-hover ${blackBG ? 'white-icon' : undefined}`} css={socialIconStyle} />
      </Link>
    </div>
  )
}

export default SocialSharing

const containerStyle = css`
  display: grid;
  grid-gap: 2rem;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  justify-content: center;
  align-items: center;
  width: fit-content;
  a {
    height: 1.5rem;
  }
`

const socialIconStyle = css`
  width: 1.5rem;
  height: 1.5rem;
`
